import { Attributes, ModelBase, NeoModel, Rules } from '@singularsystems/neo-core';

@NeoModel
export default class ClientAccount extends ModelBase {

    public clientId: number = 0;

    public clientAccountId: number | null = null;

    @Attributes.Display("Account Currency")
    public staticCurrencyId: number = 0;

    public currencyCode: string = "";

    @Rules.Required()
    @Rules.StringLength(400)
    public clientNumber: string = "";

    @Rules.StringLength(400)
    public clientName: string = "";

    @Attributes.Display("Broker")
    public staticServiceProviderFileGroupingId: number | null = null;

    public stockbrokerName: string | null = null;

    @Rules.Required()
    @Rules.StringLength(100)
    @Attributes.Display("Account Number")
    public serviceProviderAccountNumber: string = "";

    @Rules.Required()
    @Rules.StringLength(400)
    @Attributes.Display("Broker Code")
    public brokerDescription: string = "";
    
    @Rules.StringLength(100)
    @Attributes.Display("Active status")
    public activeInactive: string = "";  

    public propertiesConcatenated: string | null = null;

    public existingClient: boolean = false;

    @Rules.Required()
    @Attributes.Display("Client Entity Type")
    public clientEntityTypeId: number | null = null;

    @Attributes.Display("Client Entity Type")
    public clientEntityTypeName: string | null = null;

    public editingClientAccount: boolean = false;
}